export default {
  // Video-Chat-History
  appointmentsHistory: {
    english: "Appointments History",
    spanish: "Historial de citas",
  },
  history: {
    english: "History",
    spanish: "Historial",
  },
  noChatHistory: {
    english: "You have no video/chat history",
    spanish: "No tienes historial de video/chat",
  },
  appointments: {
    english: "Appointments",
    spanish: "Citas",
  },
  appointment: {
    english: "Appointment",
    spanish: "Cita",
  },
  date: {
    english: "Date",
    spanish: "Fecha",
  },
  topic: {
    english: "Topic",
    spanish: "Tema",
  },
  with: {
    english: "With",
    spanish: "Con",
  },
  textChatWith: {
    english: "Text Chat with",
    spanish: "Chat de texto con",
  },
  videoChatWith: {
    english: "Video Chat with",
    spanish: "Chat de video con",
  },
  to: {
    english: "to",
    spanish: "a",
  },
  momentLanguage: {
    english: "en",
    spanish: "es",
  },
  // Comes from history_chats route - chat_details.title
  "Text Chat": {
    english: "Text Chat",
    spanish: "Chat de texto",
  },
  "CPAP Supplies": {
    english: "CPAP Supplies",
    spanish: "Suministros de CPAP",
  },
  "CPAP Setup": {
    english: "CPAP Setup",
    spanish: "Configuración de CPAP",
  },
  "CPAP Machine": {
    english: "CPAP Machine",
    spanish: "Máquina de CPAP",
  },
  "Chat Now": {
    english: "Chat Now",
    spanish: "Chatea ahora",
  },
};
